import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="hide-inactive-providers"
// Toggles visibility of inactive provider cards in search results
export default class extends Controller {
  static targets = ["providerCard", "banner", "bannerText", "hideLink", "showLink"]

  hide(event) {
    event.preventDefault()
    this.providerCardTargets.forEach(card => {
      if (card.dataset.likelyActive !== "true") {
        card.style.display = "none"
      }
    })
    this.bannerTextTarget.textContent = "Hiding inactive providers."
    this.hideLinkTarget.classList.add("hidden")
    this.showLinkTarget.classList.remove("hidden")
  }

  show(event) {
    event.preventDefault()
    this.providerCardTargets.forEach(card => {
      card.style.display = ""
    })
    this.bannerTextTarget.textContent = "Showing all matching providers, even if inactive."
    this.showLinkTarget.classList.add("hidden")
    this.hideLinkTarget.classList.remove("hidden")
  }
}
